// Store Vuex para o fluxo MFA
// Persiste o sessionToken (pre_auth JWT) e os metadados da sessao MFA
// entre o /login e a tela /login/mfa

const state = {
    // sessionToken e otpExpiresAt sao preenchidos pelo retorno do /login
    // quando mfaRequired=true.
    mfaSessionToken: '',
    mfaOtpExpiresAt: null,
    // TTL em segundos calculado pelo backend no momento da emissão.
    // Usado pelo contador na tela MFA para evitar drift do relógio do cliente.
    mfaOtpExpiresInSeconds: null,
    // Janela de espera (segundos) antes de liberar o reenvio do OTP. Vem do
    // backend desacoplada do TTL do OTP — o código continua válido por
    // mfaOtpExpiresInSeconds, mas o botão de reenvio só libera após este tempo.
    mfaResendCooldownSeconds: null,
    // Momento (epoch ms) no cliente em que a sessão MFA foi recebida; usado
    // para descontar do TTL caso a tela demore a renderizar.
    mfaOtpReceivedAt: null,
    // E-mail do desafio MFA atual (vindo do retorno do /login). Fonte única de
    // verdade para a tela /login/mfa — não usar auth.email, que pode estar
    // vazio ou conter resíduo de uma sessão anterior.
    mfaEmail: '',
    // Canal pelo qual o OTP foi enviado ('email' | 'whatsapp') e o destino
    // mascarado para exibição (ex: '(41) •••••-1234'). Backend antigo não
    // envia os campos: o default 'email' mantém o comportamento atual.
    mfaChannel: 'email',
    mfaDestinationMasked: '',
    mfaWhatsAppFallback: false,
    mfaRequired: false
}

const getters = {
    isMfaPending: state => state.mfaRequired && !!state.mfaSessionToken,
    mfaExpiresAt: state => state.mfaOtpExpiresAt ? new Date(state.mfaOtpExpiresAt) : null
}

const actions = {
    setMfaSession (context, { sessionToken, otpExpiresAt, otpExpiresInSeconds, resendCooldownSeconds, email, channel, destinationMasked, whatsAppFallback }) {
        context.commit('setMfaSession', { sessionToken, otpExpiresAt, otpExpiresInSeconds, resendCooldownSeconds, email, channel, destinationMasked, whatsAppFallback })
    },
    setMfaOtpExpiry (context, { otpExpiresAt, otpExpiresInSeconds, resendCooldownSeconds, sessionToken, channel, destinationMasked, whatsAppFallback }) {
        context.commit('setMfaOtpExpiry', { otpExpiresAt, otpExpiresInSeconds, resendCooldownSeconds, sessionToken, channel, destinationMasked, whatsAppFallback })
    },
    clearMfaSession (context) {
        context.commit('clearMfaSession')
    }
}

const mutations = {
    setMfaSession (state, { sessionToken, otpExpiresAt, otpExpiresInSeconds, resendCooldownSeconds, email, channel, destinationMasked, whatsAppFallback }) {
        state.mfaSessionToken = sessionToken
        state.mfaOtpExpiresAt = otpExpiresAt
        state.mfaOtpExpiresInSeconds = (typeof otpExpiresInSeconds === 'number') ? otpExpiresInSeconds : null
        state.mfaResendCooldownSeconds = (typeof resendCooldownSeconds === 'number') ? resendCooldownSeconds : null
        state.mfaOtpReceivedAt = Date.now()
        state.mfaEmail = (typeof email === 'string') ? email : ''
        state.mfaChannel = channel === 'whatsapp' ? 'whatsapp' : 'email'
        state.mfaDestinationMasked = (typeof destinationMasked === 'string') ? destinationMasked : ''
        state.mfaWhatsAppFallback = state.mfaChannel === 'email' && whatsAppFallback === true
        state.mfaRequired = true
    },
    setMfaOtpExpiry (state, { otpExpiresAt, otpExpiresInSeconds, resendCooldownSeconds, sessionToken, channel, destinationMasked, whatsAppFallback }) {
        state.mfaOtpExpiresAt = otpExpiresAt
        state.mfaOtpExpiresInSeconds = (typeof otpExpiresInSeconds === 'number') ? otpExpiresInSeconds : null
        state.mfaResendCooldownSeconds = (typeof resendCooldownSeconds === 'number') ? resendCooldownSeconds : null
        state.mfaOtpReceivedAt = Date.now()
        // Resend bem-sucedido devolve novo pre-auth JWT alinhado ao novo OTP.
        // Quando vier no payload, atualizamos para evitar 401 na próxima chamada
        // ao /verify (o token antigo expira junto com o OTP anterior).
        if (typeof sessionToken === 'string' && sessionToken.length > 0) {
            state.mfaSessionToken = sessionToken
        }
        // O reenvio pode trocar de canal (ex.: WhatsApp falhou e o backend
        // caiu para e-mail). Só atualiza quando o campo vier no payload.
        if (channel === 'whatsapp' || channel === 'email') {
            state.mfaChannel = channel
            state.mfaDestinationMasked = (typeof destinationMasked === 'string') ? destinationMasked : ''
            // Reenvio feito com o código anterior já expirado volta sem a marca
            // do fallback (o servidor não tem mais de onde tirá-la).
            state.mfaWhatsAppFallback = channel === 'email' &&
                (whatsAppFallback === true || state.mfaWhatsAppFallback)
        }
    },
    clearMfaSession (state) {
        state.mfaSessionToken = ''
        state.mfaOtpExpiresAt = null
        state.mfaOtpExpiresInSeconds = null
        state.mfaResendCooldownSeconds = null
        state.mfaOtpReceivedAt = null
        state.mfaEmail = ''
        state.mfaChannel = 'email'
        state.mfaDestinationMasked = ''
        state.mfaWhatsAppFallback = false
        state.mfaRequired = false
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
